<template>
<div class="collaborator-item-container">
  <div class="corp">
    <div class="corp-name">{{collaborator.corpName}}</div>
  </div>
  <div class="member">
    <div class="name-container">
      <div v-for="item in collaborator.nameList" :key="item.userId">
        <svg-icon v-if="item.confirmStatus===1&&item.userId!==hostId" icon-class="conference-accept" />
        <svg-icon v-if="item.confirmStatus===2&&item.userId!==hostId" icon-class="conference-reject" />
        {{item.name}}<span v-if="item.userId===hostId">({{$t('home.Host')}})</span>
        <span>、</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Collaborator',
  props: {
    collaborator: {
      type: Object,
      required: true,
      default: () => ({})
    },
    hostId: {
      type: String,
      default: ''
    }
  },
}
</script>

<style scoped lang="less">
.collaborator-item-container {
  padding-top: 8px;
  .corp {
    height: 22px;
    background-color: #fff;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    padding-right: 5px;
    .corp-icon {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
    .corp-name {
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      font-weight: 400;
      color: #999B9F;
      padding-left: 24px;
      border-radius: 4px;
      background: url(~@/assets/company.svg) center left / 20px 20px no-repeat;
    }
  }
  .member {
    min-height: 32px;
    line-height: 32px;
    border-radius: 4px;
    opacity: 0.7;
    border: 1px solid #FFF;
    padding: 0 8px;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    justify-content: space-between;
    .name-container {
      width: 470px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      color: #000;
      flex-wrap: wrap;
      >div:last-child span:last-child {
        display: none;
      }
    }
  }
}
</style>
